<template>
	<v-card class="mx-auto">
		<v-row>
			<v-col>
				<v-toolbar
					color="deep-purple accent-4"
					dark
				>
					<v-toolbar-title>שאלות נבחרות</v-toolbar-title>

					<v-spacer />

					<v-text-field
						v-model="questionText"
						clearable
						prepend-inner-icon="mdi-magnify"
					/>
				</v-toolbar>
				<v-toolbar
					color="deep-purple accent-4"
					dark
				>
					<v-toolbar-title v-if="game.type">
						מספר שאלות מינימלי: {{ game.type.min_questions }}
						<v-spacer />
						שאלות שנבחרו: {{ questions.length }}
					</v-toolbar-title>
				</v-toolbar>
			</v-col>
		</v-row>
		<v-row v-from-here-to-end="-50">
			<v-col>
				<v-list subheader>
					<draggable v-model="questionsToShow">
						<transition-group>
							<v-list-item
								v-for="question in questionsToShow"
								:key="question.id"
								class="game-question"
							>
								<v-list-item-content>
									<v-list-item-title>
										<v-icon>mdi-menu</v-icon>
										{{ question.question }}
									</v-list-item-title>
								</v-list-item-content>
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											small
											fab
											dark
											v-bind="attrs"
											color="danger"
											v-on="on"
											@click="remove(question)"
										>
											<v-icon dark>
												mdi-minus
											</v-icon>
										</v-btn>
									</template>
									<span>מחק שאלה</span>
								</v-tooltip>
							</v-list-item>
						</transition-group>
					</draggable>
				</v-list>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import draggable from "vuedraggable";

export default {
	name: "GameQuestions",
	components: { draggable },
	props: { questions: { required: true, type: Array, default: () => [] } },
	data () {
		return {
			questionText: "",
		};
	},
	computed: {
		questionsToShow: {
			get () {
				return this.questions.filter((question) => {
					return question.question.includes(this.questionText || "");
				});
			},
			set (val) {
				this.$emit("reorder", val);
			},
		},
		game () {
			return this.$store.state.GameModule.game;
		},
	},
	methods: {
		remove (q) {
			this.$emit("remove", q);
		},
	},
};
</script>

<style scoped>
.game-question {
  cursor: grabbing;
}
</style>
